import { z } from 'zod'
import { normalizeZambianPhone } from '@/lib/phone'
import { lusakaToday } from '@/lib/periods'

const phoneField = z
  .string()
  .refine((v) => v.trim() === '' || normalizeZambianPhone(v) !== null, {
    message: 'Enter a Zambian number like 097 123 4567',
  })

const emailField = z
  .string()
  .refine((v) => v.trim() === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()), {
    message: 'Enter an email like name@example.com',
  })

const nameField = z.string().trim().min(2, 'Enter the full name (at least 2 letters)')

export const editMemberSchema = z.object({
  fullName: nameField,
  phone: phoneField,
  email: emailField,
  notes: z.string(),
})
export type EditMemberValues = z.infer<typeof editMemberSchema>

export const addMemberSchema = z.object({
  fullName: nameField,
  phone: phoneField,
  email: emailField,
  joinedOn: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Pick the date they joined')
    .refine((v) => v <= lusakaToday(), { message: 'The date cannot be in the future' }),
})
export type AddMemberValues = z.infer<typeof addMemberSchema>
